import { render } from "./WorkProjectCard.vue?vue&type=template&id=dfd293dc"
import script from "./WorkProjectCard.vue?vue&type=script&lang=js"
export * from "./WorkProjectCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__